const allMidiCs = [24, 36, 48, 60, 72, 84, 96, 108, 120];
const allMidiBs = [23, 35, 47, 59, 71, 83, 95, 107, 119];
const allMidiDs = [26, 38, 50, 62, 74, 86, 98, 110, 122];

export function isNoteAnyC(midiNumber: number){
  return allMidiCs.includes(midiNumber);
}

export function isNoteAnyD(midiNumber: number){
  return allMidiDs.includes(midiNumber);
}

export function isNoteAnyB(midiNumber: number){
  return allMidiBs.includes(midiNumber);
}